// extracted by mini-css-extract-plugin
module.exports = {"attention":"P_dn"};